import React from 'react';
import { useQuestionStore } from '../QuestionProvider';
import styled from './index.module.scss';
import { QStatusEnum } from '@/components/AppreciationDay/index.d';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

interface QuestionBannerProps {
    showRules: () => void;
}

const QuestionBanner: React.FC<QuestionBannerProps> = ({ showRules }) => {
    const { useLang, isMobile, useRouter } = useGlobal();
    const { t } = useLang('appreciationday');
    const { questionInfo, scenario } = useQuestionStore();
    const { locale } = useRouter();

    const getBannerSrc = () => {
        if (!scenario) {
            return require(`@publicLocal/appreciation-day/${isMobile ? 'h5' : 'pc'}/banner-question.png`);
        }
        if (scenario === 'active_eu') {
            if (!isMobile) {
                return 'https://websiteoss.ecoflow.com/upload/image/1726110429450/banner_question_pc.png';
            }
            return 'https://websiteoss.ecoflow.com/upload/image/1726110535418/banner_question_m.png';
        }
        if (scenario === 'active_za') {
            if (!isMobile) {
                return 'https://websiteoss.ecoflow.com/upload/image/1726110429450/banner_question_pc.png';
            }
            return 'https://websiteoss.ecoflow.com/upload/image/1726110535418/banner_question_m.png';
        }
        if (scenario === 'active_na') {
            if (!isMobile) {
                return 'https://websiteoss.ecoflow.com/upload/image/1728889586513/pc-na-question-bg.png';
            }
            return 'https://websiteoss.ecoflow.com/upload/image/1728889591026/m-na-question-bg.png';
        }
        return '';
    };

    if (!questionInfo) return <></>;

    return (
        <div className={`${styled.question_banner} ${scenario ? scenario : ''}`}>
            <h5 className="title">{questionInfo.campaignName}</h5>
            <p className="subtitle">
                {questionInfo.subTitle} <span onClick={showRules}>{t('question.rules')}</span>
            </p>
            {/* {['de', 'fr', 'it'].includes(locale) && <p className="join_community">{t('question.join_community')}</p>} */}
            <div className="banner">
                <NextImage src={getBannerSrc()} alt={t('banner.title')} aria-label={t('banner.title')} />
                <div className="text_box">
                    {questionInfo?.answerStatus === QStatusEnum.FIRST || questionInfo?.answerStatus === QStatusEnum.NONE || !questionInfo.questionGroupId ? (
                        <p className="welcome">{t('question.welcome')}</p>
                    ) : (
                        <div className="score">
                            <p className="title">{t('question.rewards')}</p>
                            <div className="score_box">
                                <div className="item">
                                    <p className="num">{questionInfo.rewardTotalPoints || 0}</p>
                                    <p>{t('question.ecoCredits')}</p>
                                </div>
                                {/* <div className="line"></div>
                                <div className="item">
                                    <p className="num">0</p>
                                    <p>{t('question.coupons')}</p>
                                </div> */}
                            </div>
                            {questionInfo?.answerStatus === QStatusEnum.NEXT && <p className="desc">{t('question.continue')}</p>}
                        </div>
                    )}
                </div>
            </div>
            {questionInfo.ruleDescription && <div className="tips">{questionInfo.ruleDescription}</div>}
        </div>
    );
};

export default QuestionBanner;
